/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import { useMaterialUIController, setDarkMode } from "common/context";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";

// Material Dashboard 2 React example components

import PageLayout from "common/components/implemented/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/components/Footer2";
import { useEffect, useRef } from "react";

function BasicLayout({ image, children }) {

 const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
 // ricorda se la modalità scura era attiva quando si è entrati nella pagina
  const eraScuro = useRef(darkMode);

  useEffect(() => {
    if (eraScuro.current) {
      setDarkMode(dispatch, false);
    }
    return () => {
      if (eraScuro.current) {
        setDarkMode(dispatch, true);
      }
    };
  }, [dispatch]);


  return (
    <PageLayout>
     {/* <DefaultNavbar
        action={{
          type: "external",
          route: "https://creative-tim.com/product/material-dashboard-react",
          label: "free download",
          color: "dark",
        }}
      />*/}
      <MDBox 
         display="flex"
        flexDirection="column"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.2),
              rgba(gradients.dark.state, 0.2)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: { xs: "scroll", md: "fixed" },
        }}
     >
    {/* Contenuto: cresce con la card, nessuna altezza fissa */}
        <MDBox
          flex="1 0 auto"
          display="flex"
          alignItems="center"
          justifyContent="center"
          px={2}
          pt={{ xs: 6, md: 8 }}
          pb={4}
        >
          <MDBox width="100%" maxWidth="440px">
            {children}
          </MDBox>
        </MDBox>
      <Footer light />
      </MDBox>
    </PageLayout>
  );
}

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
